import type { PipelineParams } from '@core/stages-types';

export const defaultPipelineParams: PipelineParams = {
  sort_by: null,
  sort_order: null,
  qualified: true,
  disqualified: false,
  with_created_at: true,
  with_evaluations: true,
  with_pending_result_requests: true,
  with_my_pending_result_requests: true,
  with_ai_screening: true,
  with_integrations: false,
  with_last_activity_at: false,
  with_name: true,
  with_notes_count: true,
  with_overdue_at: true,
  with_locations: true,
  with_social_links: false,
  with_tags: false,
  with_tasks_count: true,
  with_upcoming_events: true,
};

export const PAGINATED_PIPELINE_PAGE_SIZE = 20;
